import { AccountApi } from './common/api/account-api';
import { BonusSettlementsApi } from './features/bonus-settlements/api/bonus-settlements-api';
import { CommonApi } from './common/api/api';
import { CustomerApi } from './common/api/customer-api';
import { InquiryApi } from './common/api/inquiry-api';
import { NotificationsApi } from './common/api/notifications-api';
import { OfferApi } from './common/api/offer-api';
import { PurchaseOrdersApi } from './common/api/purchase-orders-api';
import { UserManagementApi } from './common/api/user-management-api';

export class Api {
    constructor(private baseUrl: string) {
        this.account = new AccountApi(this.baseUrl);
        this.common = new CommonApi(this.baseUrl);
        this.customers = new CustomerApi(this.baseUrl);
        this.offer = new OfferApi(this.baseUrl);
        this.inquiry = new InquiryApi(this.baseUrl);
        this.purchaseOrders = new PurchaseOrdersApi(this.baseUrl);
        this.userManagement = new UserManagementApi(this.baseUrl);
        this.notifications = new NotificationsApi(this.baseUrl);
        this.bonusSettlements = new BonusSettlementsApi(this.baseUrl);
    }

    public account: AccountApi;
    public common: CommonApi;
    public customers: CustomerApi;
    public offer: OfferApi;
    public inquiry: InquiryApi;
    public purchaseOrders: PurchaseOrdersApi;
    public userManagement: UserManagementApi;
    public notifications: NotificationsApi;
    public bonusSettlements: BonusSettlementsApi;
}
